import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001/api',
  timeout: 15000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('solvert_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = err.config?.url || '';
    const esLoginEndpoint = url.includes('/auth/login') || url.includes('/auth/recuperar');
    if (err.response?.status === 401 && !esLoginEndpoint) {
      localStorage.removeItem('solvert_token');
      localStorage.removeItem('solvert_tecnico');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
